import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";
import { createLabourAndPacking, updateLabourAndPacking } from "../../redux/action/labour-and-packing";

interface ChooseServiceProps {
  onNext: (service: string) => void;
  onBack: () => void;
  step: any;
}

const ChoosePackingService: React.FC<ChooseServiceProps> = ({
  onNext,
  onBack,
  step,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedService, setSelectedService] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState<string | null>(null);
  const {canonicalId} = useParams()
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedService(event.target.value);
  };
  const { businessName } = useParams();

  const handleContinue = async () => {
    if (!selectedService) {
      return;
    }
    const sendData = {
      isPack_and_load: selectedService === "pack_load",
      isPacking_only: selectedService === "pack_only",
      isLoading_only: selectedService === "load_unload",
      canonical_id:canonicalId
    };
    try {
      if(canonicalId){
        const res = await dispatch<any>(updateLabourAndPacking(sendData));
        const result = unwrapResult(res);
        const newCanonicalId = result.canonical_id;
        onNext(selectedService)
        navigate(`/${businessName}/labour-and-packing/${newCanonicalId}`);
      }
   
    } catch (err: any) {
      setError(err?.message || "Failed to create move service");
    }
    // onNext(selectedService);
  };

  const handleBack = () => {
    navigate(`/${businessName}/select-service`);
  };
  return (
    <div>
      <Container
        sx={{
          width: "100%",
          maxWidth: "100%",
          height: isMobile ? "93vh" : "80vh",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
          padding: isMobile ? "20px" : "20px",
          background: "#f2f0f0",
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Typography
            fontWeight={700}
            fontSize={isMobile ? "16px" : "18px"}
            textAlign="center"
            mb={2}
          >
            Please choose which service you would like:
          </Typography>
          <Divider sx={{ background: "#D3D3D3" }} />

          <FormControl
            component="fieldset"
            sx={{ width: "100%", mt: 2, textAlign: "left" }}
          >
            <RadioGroup value={selectedService} onChange={handleChange}>
              {[
                {
                  value: "pack_load",
                  label: "Pack and Load (we pack and load your truck)",
                },
                {
                  value: "pack_only",
                  label: "Pack Only (packing your items)",
                },
                {
                  value: "load_unload",
                  label: "Load or Unload Only (you pack, we load/unload)",
                },
                // {
                //   value: "pack_unpack",
                //   label: "Pack & UnPack Local Only",
                // },
              ].map((option, index) => (
                <Box key={option.value}>
                  <FormControlLabel
                    value={option.value}
                    control={
                      <Radio
                        sx={{
                          color: theme.palette.primary.main,
                          "&.Mui-checked": {
                            color: theme.palette.primary.main,
                          },
                        }}
                      />
                    }
                    label={option.label}
                    sx={{
                      width: "100%",
                      padding: "8px 0",
                      fontSize: isMobile ? "14px" : "16px",
                    }}
                  />
                  {index < 3 && <Divider sx={{ background: "#D3D3D3" }} />}
                </Box>
              ))}
            </RadioGroup>
          </FormControl>
        </Box>

        <Box
          sx={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: "20px",
            marginTop: "auto",
          }}
        >
          <Button
            variant="outlined"
            sx={{
              borderRadius: "20px",
              borderColor: theme.palette.primary.main,
              color: theme.palette.primary.main,
              padding: isMobile ? "8px 20px" : "8px 45px",
              textTransform: "none",
              fontSize: isMobile ? "12px" : "14px",
              fontWeight: "600",
            }}
            onClick={handleBack}
          >
            Back
          </Button>
          <Button
            variant="contained"
            sx={{
              borderRadius: "20px",
              backgroundColor: theme.palette.primary.main,
              color: "#fff",
              padding: isMobile ? "8px 20px" : "8px 45px",
              textTransform: "none",
              fontSize: isMobile ? "12px" : "14px",
              fontWeight: "600",
              "&:hover": { backgroundColor: "#357ABD" },
            }}
            onClick={handleContinue}
            disabled={!selectedService}
          >
            Continue
          </Button>
        </Box>
      </Container>
    </div>
  );
};

export default ChoosePackingService;
